import React from "react";

import Jumbotron from "../../component/Jumbotron";
import Text from "../../component/Text";
import SmoothTimeLine from "../../component/TimeLine/timelineSmooth";

const cards = [
  {
    role: "Software engineer",
    key: "000",
    company: "SWYM",
    date:"April 2021 - present",
    points:[ "WIP",
  ],
    description:
      "WIP",
  },
  {
    role: "Senior full stack developer",
    key: "002",
    company: "Wendor",
    date:"Jan 2019 - April 2021",
    points:[ "Part of the product design team.", 
       "Implemented mqtt based architecture resulting in the fastest multiple vendings from the vending machine.",
       "Developed dashboard using react and nodejs for remote monitoring vending machines. PWA app is available on desktops, android and iOS.",
       "Improved mobile app performance by 200% by using google’s latest TWA technology in dashboard, swift and refiller apps.",
       "Created beta and prod environment with nodejs app for simulating real life scenarios . Resulting reliable and fast developer experience. ",
       "Managed vending machines in AMAZON SAMBHAV (2019) event.",
       "Developed gift voucher vending kiosk for DLF malls diwali celebration event (2019).",
  ],
    description:
      "I have worked and created around 10+ websites and apps. Worked on hardware level as well. I also lead team of really great people. ",
  },
  {
    role: "Web developer ",
    key: "003",
    date:"July 2018 - 2019",
    company: "GDTech",
    points:[
      "Worked alongside with another developer to implement an e-commerce app for users to add subscriptions for products. ",
      "Admin dashboard to manage dairy farm stocks and products. ",
      "Won PUSAKrishi Incubator with 10 lakh funding. ",
    ],
    description: "Worked on website for Dairy farm management system. Got to meet great programmers",
  },
];

const AboutMe: React.FC = () => {
  return (
    <Jumbotron
      flexDirection="column"
      justifyContent="center"
      textAlign="center"
      minHeight="100vh"
    >
      <Text text="ABOUT ME" fs="60px" fontWeight="bold" />
      <Jumbotron
        height="17%"
        padding="100px 0 100px 0"
        width="60%"
        margin="0px auto"
        flexDirection="column"
      >
      <Text
        margin="5px 0"
        text="👉 Stackoverflow 2000+  reputation"
      />
        <Text
          margin="5px 0"
          text="👉 I have developed multiple websites and handling them on day to day basis"
        />
        <Text
          margin="5px 0"
          text="👉 Worked with jenkins and aws occasionally."
        />
        <Text
          margin="5px 0"
          text="👉 Hosted 10 competitions on websites that, I created in college life."
        />
        <Text margin="5px 0" text="👉 Love to read books." />
        <Text
          margin="5px 0"
          text="👉 When free, I blend relaxing videos using blender."
        />
        <Text margin="5px 0" text="👉 Rainbow Six Siege gold ⭐ player " />
      </Jumbotron>

      <Jumbotron
        height="40%"
        padding="10px 0"
        width="90%"
        margin="0px auto"
        flexDirection="column"
      >
        <SmoothTimeLine data={cards}/>
      </Jumbotron>
    </Jumbotron>
  );
};

export default AboutMe;
